export default "__VITE_ASSET__Bw8SPiXF__"